let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8n8M3")).then(() => parcelRequire('4YERU'));